/*
 * @Descripttion:
 * @version:
 * @Author: lxh3@meitu.com
 * @Date: 2025-06-06 14:35:16
 * @LastEditors: lxh3@meitu.com
 * @LastEditTime: 2025-06-12 14:34:02
 */
import React, { useEffect, useState } from 'react';
import useUploadThreadStore, { removeThread } from '$/store/useUploadThreadStore';
import { useLanguageStore } from '$/store/languageStore';
import { replaceTemplateParams } from '$/utils';
import Styles from './index.module.scss';
import IconFont from '../IconFont';

const MAX_UPLOAD_PROGRESS = 90; // 上传进度最大值占比
const DETECT_MAX_PROGRESS = 10; // 检测进度最大值占比
export default function UploadLoadingProgress() {
  const uploadThread = useUploadThreadStore((state) => state.uploadThread);
  const [detectProgressMap, setDetectProgressMap] = useState<Record<string, number>>({});
  const languageStore = useLanguageStore((state) => state.languageStore);

  function autoDetectProgress() {
    setDetectProgressMap((prev) => {
      const next = { ...prev };
      // eslint-disable-next-line guard-for-in
      for (const threadId in uploadThread) {
        const thread = uploadThread[threadId];
        if (thread.done === thread.total && !thread.detected) {
          next[threadId] = Math.min((next[threadId] || 0) + 1, 10);
        }
      }
      return next;
    });
  }
  useEffect(() => {
    const interval = setInterval(autoDetectProgress, 200);
    return () => clearInterval(interval);
  }, [uploadThread]);

  function autoRemoveThread() {
    Object.entries(uploadThread).forEach(([threadId, thread]) => {
      if (thread.detected || thread.canceled) {
        setTimeout(() => {
          removeThread(threadId);
          setDetectProgressMap((prev) => {
            const { ...rest } = prev;
            return rest;
          });
        }, 500);
      }
    });
  }
  useEffect(() => {
    autoRemoveThread();
  }, [uploadThread]);

  return (
    <div className={Styles.upload_loading_progress}>
      {Object.entries(uploadThread).map(([threadId, thread]) => {
        const {
          done = 0, total, detected,
        } = thread;

        const uploadRatio = total === 0 ? 0 : done / total;
        const uploadProgress = Math.min(uploadRatio, 1) * MAX_UPLOAD_PROGRESS;

        const currentDetect = detectProgressMap[threadId] || 0;
        const detectProgress = detected ? DETECT_MAX_PROGRESS : currentDetect;

        const totalProgress = Math.round(uploadProgress + detectProgress) || 0;
        const template = languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_file_uploading);
        return (
          <div key={threadId} className={Styles.upload_loading_progress_item}>
            <div className={Styles.bar_wrapper}>
              <div
                className={Styles.progress_bar}
                style={{ width: `${totalProgress}%` }}
              />
            </div>
            <div className={Styles.progress_text}>
              <IconFont name="loadingCircleBold" fontSize={20} className={Styles.loadingIcon} />
              {total > 1 ? replaceTemplateParams(template, {
                num: total,
              }) : languageStore.smartcatTranslationText((v) => v.RoboNeo_Web_file_uploading_single)}
              ...
            </div>
          </div>
        );
      })}
    </div>
  );
}
